$('.collection_prd_list').slick({
  infinite: true,
  arrows:true,
  slidesToShow: 6,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        arrows: false,
        slidesToShow: 4
      }
    },
    {
      breakpoint: 749,
      settings: {
        arrows: false,
        slidesToShow: 2
      }
    }
  ]
});

jQuery(".faq_box h5").first().addClass("show");
jQuery(".faq_box  h5").click(function(){if(jQuery(this).hasClass("show"))
{jQuery(this).removeClass("show");jQuery(this).next().slideUp();}
else
{jQuery(".faq_box h5").removeClass("show");jQuery(".faq_box h5").next().slideUp();jQuery(this).addClass("show");jQuery(this).next().slideDown();}});


if($(window).width() <= '749'){
  $('.home_tab-content').slick({
    infinite: true,
    arrows:false,
    dots:true,
    adaptiveHeight: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });
}

$(document).ready(function () {

    var navListItems = $('div.setup-panel div a'),
            allWells = $('.setup-content'),
            allNextBtn = $('.nextBtn'),
            allPrevBtn = $('.prevBtn');

    allWells.hide();

    navListItems.click(function (e) {
        e.preventDefault();
        var $target = $($(this).attr('href')),
                $item = $(this);

        if (!$item.hasClass('disabled')) {
            navListItems.removeClass('btn-primary').addClass('btn-default');
            $item.addClass('btn-primary');
            allWells.hide();
            $target.show();
            $target.find('input:eq(0)').focus();
        }
    });

    allNextBtn.click(function(){
        var curStep = $(this).closest(".setup-content"),
            curStepBtn = curStep.attr("id"),
            nextStepWizard = $('div.setup-panel div a[href="#' + curStepBtn + '"]').parent().next().children("a"),
            curInputs = curStep.find("input[type='text'],input[type='url']"),
            isValid = true;

        $(".form-group").removeClass("has-error");
        for(var i=0; i<curInputs.length; i++){
            if (!curInputs[i].validity.valid){
                isValid = false;
                $(curInputs[i]).closest(".form-group").addClass("has-error");
            }
        }

        if (isValid)
            nextStepWizard.removeAttr('disabled').trigger('click');
    });

    allPrevBtn.click(function(){
        var curStep = $(this).closest(".setup-content"),
            curStepBtn = curStep.attr("id"),
            prevStepWizard = $('div.setup-panel div a[href="#' + curStepBtn + '"]').parent().prev().children("a");

        $(".form-group").removeClass("has-error");
        prevStepWizard.removeAttr('disabled').trigger('click');
    });

    $('div.setup-panel div a.btn-primary').trigger('click');
});

var btn = $('#top_button');

$(window).scroll(function() {
  if ($(window).scrollTop() > 300) {
    btn.addClass('show');
  } else {
    btn.removeClass('show');
  }
});

btn.on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({scrollTop:0}, '300');
});


  const searchForm = document.getElementById("search-form-zipcode") ;
  const searchInput = document.getElementById("search-zip-code");
  const searchButton = document.getElementById("search-scooter");
  
  if(searchForm){
    searchForm.addEventListener("submit", function(event) {
      event.preventDefault();
      searchButton.click();
    });
  }
  if(searchInput){
      searchInput.addEventListener("keydown", function(event) {
        if (event.key === "Enter") {
          event.preventDefault();
          searchButton.click();
        }
      });
    }
  // searchButton.addEventListener("click", function() {
  //   //alert("Search button clicked!");
  //   const collectionEmpty = document.querySelector(".collection--empty");

  //   if (collectionEmpty) {
  //     // Redirect to the /collections/all-inventory URL
  //     window.location.href = "/collections/all-inventory";
  //   } else {
  //     // Add your JavaScript logic here for handling the search button click
  //   //  alert("Search button clicked!");
  //     // You can remove the alert and add your actual search functionality
  //   }
  // });
  const collectionEmpty = document.querySelector(".collection--empty");

    if (collectionEmpty) {
      // Redirect to the /collections/all-inventory URL
      window.location.href = "/collections/all-inventory";
    } else {
      // Add your JavaScript logic here for handling the search button click
    //  alert("Search button clicked!");
      // You can remove the alert and add your actual search functionality
    }
